<header>
  <div class="header-logo">
    <span class="logo-text-green">國泰健康管理</span>
    <div class="logo-divider"></div>
    <span class="logo-sub">Happy Habit 每日衡好選</span>
  </div>
</header>

<main class="maintenance-container">
  <!-- <h1>因預約人數眾多</h1>
  <h2>
  請於15分鐘後重新嘗試
</h2>

    <div class="maintenance-msg">
      <h3>為確保每一位貴賓的預約流程順暢。 </h3>
      <h3> 造成您的不便，敬請見諒。 </h3>

    </div> -->
      <h1>系統修復中</h1>
       <div class="maintenance-msg">
    <h3>很抱歉，系統修復中，預計於{{ targetOpeningTime }}<br> 開放使用</h3>
    <p>如需協助請聯繫客服</p>
    <p class="tel-info">客服專線：{{ customerServicePhone }}</p>
  </div>
</main>